import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../components/Loading";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";


const CityListFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openCountry, setOpenCountry] = useState(false);
    const [openState, setOpenState] = useState(false);
    const [openDistrict, setOpenDistrict] = useState(false);

    //options states
    const [options, setOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    
    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "6px 8px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    useEffect(() => {
        if(!open){
            return;
        }
        fetchCountryList();
        fetchStateList();
        fetchDistrictList();
    },[open]);

    const fetchCountryList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/country?dropdown=true&isActive=true`)

            if(response?.success){
                const formattedCountries = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.displayName,
                }));
                setCountryOptions(formattedCountries)
            }
            else{
                //throw error
                showSnackbar("Error Fetching Country List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Countries:', error);
            showSnackbar("Error Fetching Country List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchStateList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/state?dropdown=true&isActive=true`)

            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setStateOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching City List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Cities:', error);
            showSnackbar("Error Fetching City List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchDistrictList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/district?dropdown=true&isActive=true`)

            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching District List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Districts:', error);
            showSnackbar("Error Fetching District List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            countryId: "",
            stateId: "",
            districtId: "",
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 250,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                City Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
            maxHeight: 300, 
            overflowY: "auto"}}>
            <Grid2 container>
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="subtitle2" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Country*/}
                <Grid2 size={{xs:12}}>
                    <MaterialBox mt={1}>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenCountry(!openCountry)}>
                        <MaterialTypography variant="subtitle2" fontWeight="bold">
                            Country
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openCountry ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openCountry}>
                        {countryOptions?.map((country) => (
                            <MenuItem
                            key={country.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "countryId", value: country.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.countryId === country.value} />}
                                label={country.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* State*/}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox mt={1}>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenState(!openState)}>
                            <MaterialTypography variant="subtitle2" fontWeight="bold">
                            State
                            </MaterialTypography>

                            <IconButton size="small">
                            <ExpandMore
                                sx={{
                                transform: openState ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                                }}
                            />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openState}>
                            {stateOptions?.map((state) => (
                            <MenuItem
                                key={state.value}
                                disableRipple
                                sx={menuItemStyle}
                                onClick={() =>
                                handleChange({
                                    target: { name: "stateId", value: state.value },
                                })
                                }
                            >
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    size="small"
                                    checked={filterData.stateId === state.value}
                                    />
                                }
                                label={state.label}
                                sx={labelStyle}
                                />
                            </MenuItem>
                            ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* District */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox mt={1}>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenDistrict(!openDistrict)}>
                            <MaterialTypography variant="subtitle2" fontWeight="bold">
                                District
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openDistrict ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openDistrict}>
                        {options?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "districtId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.districtId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>
        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#93a6e8",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#bcc7e9",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default CityListFilterDialog;
